import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'primereact/button';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import BpnsHelperLink from '../../../../../../shared/components/bpns-helper-link/BpnsHelperLink';
import {
  createSiteSchema,
  SiteFormData,
} from '../../../../../../shared/helpers/create-site-schema';
import { ISite } from '../../../../../../shared/interfaces/ISite';
import TextInput from '../../../../../forms/text-input/TextInput';

export type InlineAddSiteFormData = SiteFormData;

type InlineAddSiteFormProps = {
  existingSites: ISite[];
  isSubmitting: boolean;
  onSubmit: (data: InlineAddSiteFormData) => void;
  onCancel: () => void;
};

const InlineAddSiteForm = ({
  existingSites,
  isSubmitting,
  onSubmit,
  onCancel,
}: InlineAddSiteFormProps): JSX.Element => {
  const { t } = useTranslation();

  const { control, handleSubmit } = useForm<InlineAddSiteFormData>({
    defaultValues: { name: '', bpns: '' },
    resolver: yupResolver(createSiteSchema(existingSites, t)),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  return (
    <div className='flex flex-column'>
      <small className='text-color-secondary mb-3'>
        {t('addCertificateDialog.inputs.enclosedSitesHelper')}
      </small>

      <div className='flex flex-column'>
        <TextInput
          name='name'
          label={t('manageSitesDialog.inlineForm.siteName')}
          control={control}
          placeholder={t('manageSitesDialog.inlineForm.siteNamePlaceholder')}
          autoComplete='off'
        />

        <TextInput
          name='bpns'
          label={t('manageSitesDialog.inlineForm.bpns')}
          control={control}
          placeholder={t('manageSitesDialog.inlineForm.bpnsPlaceholder')}
          style={{ fontFamily: 'monospace' }}
          autoComplete='off'
        />

        <BpnsHelperLink className='pl-1' />
      </div>

      <div className='flex flex-row gap-2 w-full justify-content-end'>
        <Button
          label={t('manageSitesDialog.buttons.cancel')}
          className='w-fit'
          outlined
          size='small'
          onClick={onCancel}
          type='button'
        />
        <Button
          label={t('manageSitesDialog.buttons.save')}
          className='w-fit'
          size='small'
          onClick={handleSubmit(onSubmit)}
          loading={isSubmitting}
          type='button'
        />
      </div>
    </div>
  );
};

export default InlineAddSiteForm;
